import * as z from "zod/mini";
import { devBaseSchema, parseFrameConfig, themeBaseSchema } from "../../lib/parse-frame-config";

const publicSchema = z.extend(themeBaseSchema, {
  channelId: z._default(z.string(), ""),
  clientToken: z._default(z.string(), ""),
  /**
   * Alpha-2 country code that biases Places autocomplete when set. Defaults to
   * empty (no bias) so any country's address is typeable; the integrator opts in
   * to a region by passing a country. The manual-entry submit country falls back
   * separately in `use-billing-draft` so an empty default never ships `country: ""`.
   */
  country: z._default(z.string(), ""),
});

const devSchema = z.object({
  ...devBaseSchema.shape,
  /** VGS env: sandbox (default) or live. */
  vgsEnvironment: z._default(z.enum(["live", "sandbox"]), "sandbox"),
  /** Dev error injection: tokenize | save | network | decline. */
  forceError: z._default(z.enum(["", "tokenize", "save", "network", "decline"]), ""),
});

const KNOWN_KEYS = new Set([...Object.keys(publicSchema.shape), ...Object.keys(devSchema.shape)]);

export type AddCardConfig = z.infer<typeof publicSchema> & z.infer<typeof devSchema>;

export function parseConfig(search?: string): AddCardConfig {
  const { config, devConfig } = parseFrameConfig({
    publicSchema,
    devSchema,
    knownKeys: KNOWN_KEYS,
    search,
  });
  return { ...config, ...devConfig };
}
